/*
 * @Author: 王枫叶
 * @Date: 2020-10-31 17:53:35
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-17 21:24:56
 */
import Main from "../views/main";
// 活动管理
import ActivityRouter from "./activity";
// 管理员路由
import Administrators from "./administrators";
// 广告管理
import AdvertisingRouter from "./advertising";
// 代理管理
import AgentRouter from "./agent";
// 渠道管理
import VideoRouter from "./video";
// 影院管理
import CinemaRouter from "./cinema";
// 热点管理
import hotRouter from "./hotSpot";
// 裸聊专区
import NakedChatRouter from "./nakedChat";
// 落地页管理
import LandRouter from "./land";
// 产品管理
import productRouter from "./product";
// 机器人管理
import RobotConfig from "./robot";
// 统计路由
import StatisticsRouter from "./statistics";
// 系统管理
import SystemRouter from "./system";
// 系统消息
import SystemMessageRouter from "./systemMessage";
// 交易管理
import TransactionRouter from "./transaction";
// 用户路由
import UserRouter from "./user";
//商区代理路由
import AgentDistrictRouter from "./agentDistrictProvider";
// 聚商路由
import GatheringRouter from "./gathering";
//商人路由
import BusinessRouter from "./business";
//楼凤管理
import Loufeng from "./loufeng";
//小说管理
import FictionRouter from "./fiction";
//水果管理
import AvComment from "./avcomment";
//女优管理
import ActressRouter from "./actress";
//签到管理
// import SigninRouter from "./signin";
//模块配置管理
import moduleConf from "./moduleConfig";
//合集管理
import PlaylistRouter from "./playlist";
import animation from "./animation";
// 老司机资源库
import LsjMediaLibRouter from "./lsjMediaLibRouter";
// 不需要权限控制的路由
const authRouter = [{
    path: "/home",
    component: Main,
    title: "首页",
    icon: "el-icon-s-home",
    level: 0,
    children: [{
      path: "/home",
      component: () => import("@/views/home/index"),
      name: "home",
      title: "首页",
      meta: {
        title: "首页"
      },
    }, ],
  },
  Administrators,
  VideoRouter,
  PlaylistRouter,
  moduleConf,
  LsjMediaLibRouter,
  animation,
  UserRouter,
  StatisticsRouter,
  TransactionRouter,
  productRouter,
  ActivityRouter,
  AgentRouter,
  NakedChatRouter,
  LandRouter,
  AdvertisingRouter,
  SystemMessageRouter,
  SystemRouter,
  RobotConfig,
  hotRouter,
  CinemaRouter,
  GatheringRouter,
  BusinessRouter,
  Loufeng,
  AvComment,
  ActressRouter,
  FictionRouter,
  // SigninRouter,
  {
    path: "/roleManagement",
    component: Main,
    title: "权限管理",
    icon: "el-icon-s-custom",
    level: 0,
    children: [{
      path: "/roleManagement",
      component: () => import("@/views/role/index"),
      name: "roleManagement",
      title: "权限管理",
      meta: {
        title: "权限管理"
      },
    }, ],
  },
  AgentDistrictRouter,
];
export default authRouter;